import { RiLoader4Line } from '@remixicon/react';
import type { ReactElement } from 'react';

import css from './styles.module.css';

/** Shown while the session or a page's data is still on its way. */
export function PageLoader(): ReactElement {
	return (
		<div className={css.loader} role="status" aria-label="Loading">
			<RiLoader4Line aria-hidden="true" />
		</div>
	);
}
